export default "__VITE_ASSET__DdZVkl1S__"